import styled from 'styled-components'
import { mobileBreakpoint } from 'react-components'
import { SearchbarMode } from '../../search-result-listing/header-section/types'

export const SearchbarContainer = styled.div<{
    maxWidth?: string
    searchbarMode?: SearchbarMode
    isBorderGradientEnabled?: boolean
}>`
    display: ${props => props.theme.style.display.flex};
    flex: 1;
    max-height: 4rem;
    height: ${props => (props.searchbarMode === SearchbarMode.PILL ? '2.9rem' : '4rem')};
    width: ${props => (props.searchbarMode === SearchbarMode.PILL ? '100%' : '85%')};
    max-width: 81.7rem;
    border-radius: ${props => (props.searchbarMode === SearchbarMode.PILL ? '6px' : '1rem')};
    box-shadow: ${props =>
        props.searchbarMode === SearchbarMode.PILL
            ? 'none'
            : `0 0.375rem 1rem ${props.theme.colors.tfwBlackOpacity10}`};
    justify-content: center;
    align-items: center;

    border: ${({ searchbarMode, theme, isBorderGradientEnabled }) =>
        searchbarMode === SearchbarMode.PILL
            ? '1px solid #00000019'
            : isBorderGradientEnabled
            ? '3px solid transparent'
            : `0.125rem solid ${theme.colors.tfwYellow}`};

    background: ${({ searchbarMode, theme, isBorderGradientEnabled }) =>
        searchbarMode === SearchbarMode.PILL
            ? theme.colors.white
            : isBorderGradientEnabled
            ? `
                linear-gradient(${theme.colors.white}, ${theme.colors.white}) padding-box,
                linear-gradient(180deg, #FFFFFF 7.81%, #FDC400 169.53%) border-box
            `
            : theme.colors.white};

    @media only screen and (max-width: ${mobileBreakpoint.max}px) {
        padding: ${props => (props.searchbarMode === SearchbarMode.PILL ? '0.5rem' : '0.5rem 0 0 0')};
        max-height: fit-content;
        margin-bottom: ${props => (props.searchbarMode === SearchbarMode.PILL ? '0' : '0.7rem')};
        max-width: ${props => props.maxWidth || '81.7rem'};
        border-radius: ${props => (props.searchbarMode === SearchbarMode.PILL ? '0.25rem' : '1rem')};
        width: 100%;
        scroll-margin-top: 70px;
    }
`

export const SearchbarContent = styled.div<{ maxWidth?: string; searchbarMode?: SearchbarMode }>`
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: ${props => props.maxWidth || '100%'};
    align-items: center;
    padding: 0 ${props => (props.searchbarMode === SearchbarMode.PILL ? '0' : '0.375rem')};

    @media only screen and (min-width: ${mobileBreakpoint.max}px) {
        flex-direction: row;
        gap: 0.5rem;
    }
`

export const SearchButton = styled.button<{
    padding?: string
    showMainSearchBar?: boolean
    searchbarMode?: SearchbarMode
}>`
    display: none;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    padding: ${props => props.padding || `${props.theme.spacing.small} ${props.theme.spacing.large}`};
    background-color: ${props => props.theme.colors.tfwYellow};
    border: none;
    border-radius: ${props => (props.searchbarMode === SearchbarMode.PILL ? '0 6px 6px 0' : '0.75rem')};
    cursor: pointer;
    font-weight: ${props => props.theme.typography.font.weight.semiBold};
    font-size: ${props => props.theme.typography.font.size.medium};
    color: ${props => props.theme.colors.tfwBlack87};
    white-space: nowrap;
    margin: ${props => (props.showMainSearchBar ? '0.5rem' : '0')};
    min-width: 7rem;
    min-height: ${props => (props.searchbarMode === SearchbarMode.PILL ? '2.72rem' : '2.5rem')};

    @media only screen and (min-width: ${mobileBreakpoint.max}px) {
        display: flex;
    }

    span {
        display: none;
    }

    @media only screen and (min-width: 1024px) {
        span {
            display: inline;
        }
    }

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }

    &:hover:not(:disabled) {
        background-color: ${props => props.theme.colors.tfwYellowDark};
    }

    svg {
        width: 1.5rem;
        height: 1.5rem;
    }
`

export const SubmitButton = styled.button`
    display: flex;
    width: 95%;
    padding: ${props => props.theme.spacing.medium};
    background-color: ${props => props.theme.colors.tfwYellow};
    border: none;
    border-radius: 1rem;
    cursor: pointer;
    font-weight: ${props => props.theme.typography.font.weight.semiBold};
    font-size: ${props => props.theme.typography.font.size.medium};
    color: ${props => props.theme.colors.tfwBlack87};
    justify-content: center;
    align-items: center;
    margin: 0.75rem 0.5625rem;

    @media only screen and (min-width: ${mobileBreakpoint.max}px) {
        display: none;
    }

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }

    &:hover:not(:disabled) {
        background-color: ${props => props.theme.colors.tfwYellowDark};
    }
`

export const StickyContainer = styled.div`
    display: flex;
    flex-direction: row;
    background-color: ${props => props.theme.colors.white};
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 999;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    padding: ${props => props.theme.spacing.medium} ${props => props.theme.spacing.medium};
    box-shadow: 0 0.5rem 1rem ${props => props.theme.colors.tfwBlackOpacity10};
`

export const StickySearchbarContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 2rem;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    max-width: 1200px;
`

export const Spinner = styled.div`
    width: 1.25rem;
    height: 1.25rem;
    border: 0.125rem solid ${props => props.theme.colors.tfwBlack87};
    border-top-color: transparent;
    border-radius: 50%;
    animation: spin 0.6s linear infinite;

    @keyframes spin {
        to {
            transform: rotate(360deg);
        }
    }
`

export const MobilePillContainer = styled.div<{ searchbarMode?: SearchbarMode }>`
    display: ${props => (props.searchbarMode === SearchbarMode.PILL ? 'block' : 'none')};
    width: 100%;

    @media only screen and (min-width: ${mobileBreakpoint.max}px) {
        display: none;
    }
`

export const MobilePill = styled.div.attrs({ role: 'button' })`
    text-align: center;
    overflow: hidden;
    font-size: ${props => props.theme.typography.font.size.small};
    line-height: ${props => props.theme.typography.font.size.medium};
    letter-spacing: 0.0125rem;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
    background-color: ${props => props.theme.colors.white};

    &:hover {
        background-color: ${props => props.theme.colors.tfwGrayLight};
    }
`
